import router from "../router/index.js";

let time = Date.now();

const syncQueryParams = store => {
  // called when the store is initialized

  store.subscribe((mutation, state) => {
    let query = {
      ...router.currentRoute.query
    };

    if (
      router.currentRoute.name === "map" ||
      router.currentRoute.name === "narrative"
    ) {
      let newTime = Date.now();
      if (newTime - time > 250) {
        time = Date.now();
        if (query.d !== state.geolocation.location.toFixed(5)) {
          query.d = state.geolocation.location.toFixed(5);

          router
            .replace({
              query
            })
            .catch(() => {});
        }
      }
    }

    if (mutation.payload && mutation.payload.pushToURL) {
      let queryParams = { ...router.currentRoute.query };
      Object.keys(mutation.payload.pushToURL).forEach(k => {
        queryParams[k] = mutation.payload.pushToURL[k];
      });
      router
        .replace({
          query: queryParams
        })
        .catch(() => {});
    }
  });
};

export default syncQueryParams;
